import React from 'react'

const UnResolvedTicket = () => {
  return (
    <div>UnResolvedTicket</div>
  )
}

export default UnResolvedTicket